<template>
  <b-row
    tag="a"
    no-gutters
    :class="['article', feature ? 'is-feature is-' + bgColor : '']"
    :href="link"
    target="_blank"
  >
    <b-col
      cols="12"
      class="article-img"
      v-if="!feature"
      :style="{ height: imgHeight }"
    >
      <img
        :src="img ? img : require('@/assets/images/dashboard/articlebg.png')"
        :alt="title"
      />
    </b-col>

    <b-col
      cols="12"
      :md="feature ? '4' : ''"
      :class="['article-content', feature ? 'is-' + bgColor : 'is-stretch']"
    >
      <div :class="['article-header', feature ? '' : 'is-' + bgColor]">
        <h4 class="text-primary article-tag">{{ categories }}</h4>
        <h2
          :class="[
            'mb-0 article-title',
            feature ? 'heading h1' : 'text-uppercase',
          ]"
          :title="title"
          v-line-clamp="2"
          v-html="title"
          style="word-break: break-word !important"
        ></h2>
      </div>
      <div class="article-footer" v-if="feature">
        <b-button
          pill
          :variant="variant"
          style="padding-left: 2.5rem; padding-right: 2.5rem"
          :href="link"
          target="_blank"
        >
          READ NOW
        </b-button>
      </div>
    </b-col>
    <b-col
      cols="12"
      :md="feature ? '8' : ''"
      class="article-img"
      v-if="feature"
      :style="{ height: imgHeight }"
    >
      <img
        :src="img ? img : require('@/assets/images/dashboard/articlebg.png')"
        :alt="title"
      />
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    feature: {
      type: Boolean,
    },
    link: {
      type: String,
    },
    title: {
      type: String,
    },
    categories: {
      type: String,
    },
    author: {
      type: String,
    },
    date: {
      type: String,
    },
    img: {
      type: String,
    },
    footerBg: {
      type: String,
      default: null,
      validator(x) {
        return ["primary", "secondary", "light", "dark", "default"].includes(x);
      },
    },
    bgColor: {
      type: String,
      default: "primary",
      validator(x) {
        return ["primary", "secondary", "light", "dark", "default"].includes(x);
      },
    },
    variant: {
      type: String,
    },
    imgHeight: {
      type: String,
      default: "385px",
    },
  },
  methods: {
    // selectItem(i) {
    //   if (!this.feature) {
    //     window.location.href = i;
    //     this.$emit('click', i)
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
$class: ".article";

.is-default {
  background-color: #fafafa;
  color: $text-color;
}

.is-primary {
  background-color: $primary;
  color: $secondary;
}

.is-secondary {
  background-color: $secondary;
  color: $white;
}

.is-dark {
  background-color: $tertiary;
  color: $white;
}

.is-light {
  background-color: $quaternary;
  color: $primary;
}

.heading.h1 {
  line-height: 32px;
}

#{$class} {
  display: flex;
  flex-wrap: wrap;
  min-height: 400px;
  margin-bottom: 1.5rem;

  &:hover {
    #{$class}-img {
      img {
        width: 120%;
        height: 120%;
      }
    }
  }

  &.is-feature {
    // #{$class}-content,
    // #{$class}-img {
    //   flex: 0 0 100%;
    //   max-width: 100%;
    // }

    #{$class}-content {
      display: flex;
      flex-flow: column;
      justify-content: space-between;

      &.is-stretch {
        flex: 0 0 100%;
        max-width: 100%;
      }
    }
  }

  // #{$class}-img,
  // #{$class}-content {
  //   flex: 0 0 100%;
  //   max-width: 100%;
  // }

  #{$class}-img {
    position: relative;
    overflow: hidden;

    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: ease-in-out 0.5s all;
    }
  }

  #{$class}-content {
    position: relative;

    #{$class}-header {
      cursor: pointer;
    }

    #{$class}-header,
    #{$class}-footer {
      padding: 1.5rem;

      @include media-breakpoint-up(xxl) {
        padding: 1.5rem * $scale-font;
      }
    }

    #{$class}-title {
      height: 50px;
      color: #19191c;
      font-size: 22px;

      @include media-breakpoint-up(xxl) {
        font-size: 22px * $scale-font;
      }
    }

    #{$class}-tag {
      font-size: 14px;
      letter-spacing: -0.02em;

      @include media-breakpoint-up(xxl) {
        font-size: 14px * $scale-font;
      }
    }

    &.is-stretch {
      display: flex;
      flex-flow: column;
      justify-content: space-between;
    }

    .text-truncate {
      position: relative;
    }

    .metadata {
      opacity: 0.75;
      letter-spacing: 0;
    }
  }
}
</style>
